export const BASE_URL = process.env.REACT_APP_BASE_URL

export const IDENTITY_SERVER = process.env.REACT_APP_IDENTITY_URL + "/HIEBus/IdentityServer/connect";

export const HIEBUS_CONFIG = (process.env.REACT_APP_CLIENT_AUTH === 'level2') ?
    {
        authorizationUrl: process.env.REACT_APP_IDENTITY_SERVER_LEVEL2 + process.env.REACT_APP_IDENTITY_SERVER_LEVEL2_AUTHORIZE,
        token_endpoint: process.env.REACT_APP_IDENTITY_SERVER_LEVEL2 + process.env.REACT_APP_IDENTITY_SERVER_LEVEL2_TOKEN,
        client_id: process.env.REACT_APP_CLIENT_ID_LEVEL2,
        client_secret: process.env.REACT_APP_CLIENT_SECRET_LEVEL2,
        response_type: "code",
        scope: "openid profile roles email offline_access",
        redirect_uri: BASE_URL + "signin-callback",
        grant_type: "authorization_code",
        user_info: process.env.REACT_APP_IDENTITY_SERVER_LEVEL2 + process.env.REACT_APP_IDENTITY_SERVER_LEVEL2_USERINFO,
        logout_uri: process.env.REACT_APP_IDENTITY_SERVER_LEVEL2 + process.env.REACT_APP_IDENTITY_SERVER_LEVEL2_LOGOUT
    } :
    {
        authorizationUrl: IDENTITY_SERVER + "/authorize",
        token_endpoint: IDENTITY_SERVER + "/token",
        client_id: process.env.REACT_APP_CLIENT_ID,
        client_secret: "testing-again",
        // response_type: "id_token token",
        response_type: "code",
        scope: "openid profile roles email offline_access",
        redirect_uri: BASE_URL + "signin-callback",
        grant_type: "refresh_token"
    };
